import RestClient from '../../../../api/axiosInterceptor';
import { pharmacyGoogleAuthActions } from '../../../actions/user/pharmacy/Account/googleAuth';
import { toast } from 'react-toastify';

/**
 * Helper function to create asynchronous actions for Redux.
 * @param {string} actionType - The action type to dispatch.
 * @param {function} apiCall - The API call function to make the request.
 */
const createAsyncAction = (actionType, apiCall) => async (dispatch) => {
  try {
    // Dispatch request action
    dispatch({ type: actionType.REQUEST });

    // API Call
    const response = await apiCall();

    // Dispatch success action
    dispatch({
      type: actionType.SUCCESS,
      payload: response.data
    });
    toast.success(response.data.message, { position: 'top-center' });

    // Store token in localStorage
    localStorage.setItem('token', response.data.token);
  } catch (error) {
    const errorMessage = error.response?.data?.message || 'Authentication failed. Please try again.';

    // Dispatch failure action
    dispatch({
      type: actionType.FAILURE,
      error: errorMessage
    });
    toast.error(errorMessage, { position: 'top-center' });
  }
};

export const pharmacyGoogleLogin = (tokenId) =>
  createAsyncAction(
    pharmacyGoogleAuthActions.GOOGLE_LOGIN,
    () => RestClient.post('/pharmacy/google-auth/login/', { tokenId })
  );

export const pharmacyGoogleRegister = (userData) =>
  createAsyncAction(
    pharmacyGoogleAuthActions.GOOGLE_REGISTER,
    () => RestClient.post('/pharmacy/google-auth/registration/', userData)
  );
